import { PlacementErrorType } from '@frontend/sports/types/betslip';

import { IncorrectBetCount } from './incorrect-bet-count';

export class IncorrectMultipleForecastCount extends IncorrectBetCount {
    constructor() {
        super(void 0, void 0);
        this.type = PlacementErrorType.IncorrectMultipleForecastCount;
    }
}
